var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "memorandum_create_block smal", class: _vm.current_class },
    [
      _c("div", { staticClass: "list_mem_create" }, [
        _vm.show_create
          ? _c(
              "div",
              { staticClass: "panel", attrs: { id: "panel_dashboard_create" } },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "panel-container show" }, [
                  _c("div", { staticClass: "panel-content" }, [
                    _c("div", { staticClass: "memchik" }, [
                      _vm.current_step === "menu_active"
                        ? _c(
                            "div",
                            { staticClass: "row-container active_block_menu" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-1 col-xs-1 mobile-1" },
                                  [
                                    _c("menu_block", {
                                      key: "menu_block_active",
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-11 col-xs-11 mobile-11",
                                  },
                                  [
                                    _c("mem_quest", {
                                      key: "menu_quest_active",
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.current_step === "menu_show"
                        ? _c(
                            "div",
                            { staticClass: "simple_block_menu" },
                            [_c("menu_block", { key: "menu_block_show" })],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "preview" },
          [
            _vm.current_step === "mem_preview"
              ? _c("mem_preview", { key: "mem_preview" })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "panel-hdr bg-primary-500 bg-success-gradient" },
      [
        _c("h2", [
          _c("span", { staticClass: "icon-stack fs-xxl mr-2" }, [
            _c("i", {
              staticClass:
                "base base-7 icon-stack-3x opacity-100 color-primary-500",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "base base-7 icon-stack-2x opacity-100 color-primary-400",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "fal fa-cog icon-stack-1x opacity-100 color-white fa-spin",
            }),
          ]),
          _vm._v("\n\t\t\t\t\t\tСтворити документ\n\t\t\t\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c("button", {
            staticClass: "btn btn-panel waves-effect waves-themed",
            attrs: {
              "data-action": "panel-fullscreen",
              "data-toggle": "tooltip",
              "data-offset": "0,10",
              "data-original-title": "Fullscreen",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }